import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { Account } from './account.contractparts';
import { RateLimit } from '../core.contractpart';

export class AccountsCreateRequestBody extends NaniumObject<AccountsCreateRequestBody> {
	@Type(String) email: string;
	@Type(String) password: string;
	@Type(String) password2: string;
	@Type(Boolean) subscribedToNewsletter: boolean;
}

@RequestType({
	responseType: Account,
	genericTypes: { TRequestBody: AccountsCreateRequestBody },
	scope: 'public',
	skipInterceptors: ['MainRequestInterceptor'],
})
@RateLimit({ perMinute: 10 })
export class AccountsCreateRequest extends ServiceRequestBase<AccountsCreateRequestBody, Account> {
	static serviceName: string = 'EduApplication:accounts/create';
}
